// src/components/PatientDetails/panels/DnaIcon.tsx
// A double-helix glyph. MUI ships no DNA icon — Biotech (a flask under a
// microscope) is the nearest and reads as "lab", not "genome" — so this is
// drawn to sit beside the MUI set: same 24x24 box, same stroke weight, so it
// does not look like a foreign asset next to Person, Medication and the rest.

import { SvgIcon, SvgIconProps } from "@mui/material";

export default function DnaIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth={1.7}
        strokeLinecap="round"
      >
        {/* The two backbones, crossing twice. */}
        <path d="M8 3c0 4.5 8 5.5 8 9s-8 4.5-8 9" />
        <path d="M16 3c0 4.5-8 5.5-8 9s8 4.5 8 9" />
        {/* Base pairs, shortest where the strands cross. */}
        <path d="M9.1 6h5.8M8 9.4h8M8 14.6h8M9.1 18h5.8" />
      </g>
    </SvgIcon>
  );
}
